




























import Vue, { PropOptions } from 'vue';
import { Location } from 'vue-router'; // eslint-disable-line import/no-extraneous-dependencies
import SCircularLoader from '../SCircularLoader/SCircularLoader.vue';

export default Vue.extend({
  name: 'SButton',
  components: {
    SCircularLoader,
  },
  props: {
    /**
     * The colour of the button
     */
    colour: {
      type: String,
      required: false,
      default: 'accent',
    } as PropOptions<'accent' | 'primary' | 'error'>,
    /**
     * If the button should be in a disabled state
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If the button should display a loading animation
     */
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * The location that the button should link to. Gets passed to v-btn > router-link.
     *
     * Have a look at the [Location interface](https://github.com/vuejs/vue-router/blob/8dadf9744e5d8431bf3e9148e66b34f4849055b5/types/router.d.ts#L107)
     * from `vue-router` for what the options are for the object
     */
    to: {
      type: [String, Object],
      required: false,
    } as PropOptions<string | Location>,
    /**
     * If the button should behave as a block element
     */
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If the button should only show text
     */
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If true the button will display as a ghost button
     */
    outline: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Should the button come with margin? We use this to reset the margin that vuetify puts on
     * by default
     */
    showMargin: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * The size of the button
     */
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
});
